<template>
  <div class="container">
    <div class="header">
      <div class="header-content">
        <div class="w1200">
          <div class="logo">
            <a href="https://www.zhongke3.com/"><img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/logo.png" alt="" /></a>
          </div>
          <div class="nav-box">
            <div
              class="li"
              v-for="(item, index) in navigation"
              :key="index"
              :class="{ on: item.key === currentNav }"
              @click="setScrollEvent(item.key)"
            >
              {{ item.name }}
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div id="bktj">
      <div class="w1200">
        <div class="title-box">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/title_label_icon01.png" class="title-label" alt="" />
        </div>
        <div class="advance">
          <ul>
            <li>
              <h3>提前面试是什么</h3>
              <p style="padding: 19px 46px 36px 58px">提前批面试，简称“提面”，是在笔试（12月份全国统考）之前参加面试， 即“先面试，后笔试”。</p>
              <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/interview_li_01.png" alt="" />
            </li>
            <li>
              <h3>提前面试的群体</h3>
              <p style="padding: 14px 45px 18px 30px">
                提前面试是商学院给工作年限较长、有管理能力，但笔试能力相对较差的学生
                可以进入院校深造的一个绿色通道，同时也是各大学校抢夺优质生源的一个 重要手段。
              </p>
              <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/interview_li_01.png" alt="" />
            </li>
          </ul>
        </div>

        <div class="title-box">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/title_label_icon02.png" class="title-label" alt="" />
        </div>

        <div class="compare">
          <div class="compare-title">
            <span>分类</span>
            <span>提前面试</span>
            <span>正常批面试（复试）</span>
          </div>
          <ul>
            <li>
              <span>面试顺序</span>
              <span>先面试，后笔试</span>
              <span>先笔试，后面试</span>
            </li>
            <li>
              <span>录取模式</span>
              <span>提面通过+笔试过国家线</span>
              <span>统考过线+复试排名择优录取</span>
            </li>
            <li>
              <span>分数线</span>
              <span>面试有难度，笔试无压力</span>
              <span>笔试压力大，复试分数线较高</span>
            </li>
            <li>
              <span>面试时间</span>
              <span>前一年的4月~11月分批进行</span>
              <span>MBA统考成绩公布后的当年3-4月</span>
            </li>
            <li>
              <span>面试机会</span>
              <span>可同时向多个院校提交申请</span>
              <span>选择机会相对提面较少</span>
            </li>
            <li>
              <span>考察重点</span>
              <span>重个人综合能力及院校匹配度</span>
              <span>重学习能力，对笔试要求比较高</span>
            </li>
          </ul>
        </div>
      </div>

      <div id="tmys">
        <div class="title-box">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/title_label_icon03.png" class="title-label" alt="" />
        </div>
        <div class="w1200">
          <div class="advantage">
            <ul>
              <li>
                <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/advantage_li_01.png" alt="" />
              </li>
              <li>
                <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/advantage_li_02.png" alt="" />
              </li>
              <li>
                <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/advantage_li_03.png" alt="" />
              </li>
              <li>
                <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/advantage_li_04.png" alt="" />
              </li>
              <li>
                <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/advantage_li_05.png" alt="" />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="analysis">
        <div class="title-box">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/title_label_icon04.png" class="title-label" alt="" />
        </div>
        <div class="w1200">
          <p class="label">1.提面考察内容：<span>提面主要通过背景评估和面试表现，全面考察考生综合能力</span></p>
          <div class="content">
            <ul>
              <li>
                <div class="l-box">
                  <div class="percent">25%</div>
                  <strong>教育背景<br />约占比25%</strong>
                </div>
                <div class="line"></div>
                <div class="r-box">毕业院校、在校期间成绩、外语水平、是否获得过奖学金等</div>
              </li>
              <li>
                <div class="l-box">
                  <div class="percent">30%</div>
                  <strong
                    >工作经历<br />
                    约占比30%</strong
                  >
                </div>
                <div class="line"></div>
                <div class="r-box">工作性质、工作业绩、担任职位、公 司规模和行业发展前景</div>
              </li>
              <li>
                <div class="l-box">
                  <div class="percent">5%</div>
                  <strong
                    >理想抱负<br />
                    约占比5%</strong
                  >
                </div>
                <div class="line"></div>
                <div class="r-box">是否有明确的职业规划，准备如何努力、 如何准备及落实等</div>
              </li>
              <li>
                <div class="l-box">
                  <div class="percent">25%</div>
                  <strong
                    >思想逻辑<br />
                    约占比25%</strong
                  >
                </div>
                <div class="line"></div>
                <div class="r-box">说话及思考逻辑、思考问题的全面性、 是否能抓住问题本质</div>
              </li>
              <li>
                <div class="l-box">
                  <div class="percent">10%</div>
                  <strong
                    >团队合作能力 <br />
                    约占比10%</strong
                  >
                </div>
                <div class="line"></div>
                <div class="r-box">团队合作如何、是否善于沟通、是否能 够挖掘他人的长处等</div>
              </li>
              <li>
                <div class="l-box">
                  <div class="percent">5%</div>
                  <strong
                    >个人修养风度<br />
                    约占比5%</strong
                  >
                </div>
                <div class="line"></div>
                <div class="r-box">个人穿衣打扮、谈吐举止、气质风度、 待人接物、为人处事</div>
              </li>
            </ul>
          </div>
          <p class="label" style="padding-top: 15px; padding-bottom: 25px">
            2.提面测评内容：
            <span
              >仪表举止、语言表达能力、逻辑分析能力、判断决策能力、自我控制能力、人际交往能力、组织协调能力、应变能力、领导能力、创业精神、创新意识以及价值取向和职业道德等多方面的能力。</span
            >
          </p>
          <p class="label">
            3.提面考核形式：<span
              >提前面试多采取“先申请、后面试”的形式，即提前面试申请材料审核通过之后才可以参加正式的面试。各院校考核形式略有不同，但面试环节整体流程区别不大，主要包括以下几种形式：</span
            >
          </p>
          <div class="table">
            <div class="table-title">
              <span>个人综合素质面试</span>
              <span>无领导小组面试</span>
              <span>时政与管理类面试</span>
              <span>英语口语面试</span>
            </div>
            <ul>
              <li>
                <span>5-30分钟不等</span>
                <span>沟通能力</span>
                <span>三种形式出现</span>
                <span>自信、流利、多说</span>
              </li>
              <li>
                <span>自我介绍</span>
                <span>随机应变能力</span>
                <span>抽题问答-随机抽一题</span>
                <span>英文面试 ≠ 英文笔试</span>
              </li>
              <li>
                <span>自由问答</span>
                <span>团队协作能力</span>
                <span>笔试-分析题、问答题</span>
                <span>忌时态/搭配/用词想太多</span>
              </li>
              <li>
                <span>抽题等多个环节</span>
                <span>领导能力</span>
                <span>论文提交-给参考书籍</span>
                <span>重在正常表达和发挥</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div id="bklc">
      <div class="w1200">
        <div class="title-box">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/title_label_icon05.png" class="title-label" alt="" />
        </div>

        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/flow_icon.png" alt="" />

        <div class="title-box">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/title_label_icon06.png" class="title-label" alt="" />
        </div>
        <div class="rule">
          <ul>
            <li>
              <div class="top">
                <p>如何筛选院校?</p>
                <span>WHICH SCHOOLS DO YOU APPLY TO?</span>
              </div>
              <div class="des">
                <p>
                  专业导师1对1指导<br />
                  择优报考2-3所院校冲刺
                </p>
              </div>
              <div class="bottom">
                <div class="button">1对1院校规划</div>
                <div class="button">申请通过率测评</div>
              </div>
            </li>
            <li>
              <div class="top">
                <p>院校报名条件?</p>
                <span>WHAT’S THE ENTRY REQUIREMENT?</span>
              </div>
              <div class="des">
                <p>
                  最新附加条件解读<br />
                  申请素材撰写指导
                </p>
              </div>
              <div class="bottom">
                <div class="button">报名条件匹配</div>
                <div class="button">报名1对1指导</div>
              </div>
            </li>
            <li>
              <div class="top">
                <p>如何科学筹备面试?</p>
                <span>HOW TO INTERVIEW SCIENTIFICALLY?</span>
              </div>
              <div class="des">
                <p>
                  如何科学筹备面试?<br />
                  个人+小组实战模拟
                </p>
              </div>
              <div class="bottom">
                <div class="button">提前面试时间查询</div>
                <div class="button">领取个人面试规划</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="precept">
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/precept_bg.png" alt="" class="precept-bg" />
        <div class="w1200">
          <div class="title-box">
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/title_label_icon07.png" class="title-label" alt="" />
          </div>

          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/precept_content_img.png" alt="" />
          <div class="form">
            <h3>填写信息 免费定制你的专属学习规划</h3>
            <p>FREE CUSTOMIZED EXCLUSIVE LEARNING PROGRAM</p>
            <div class="form-box">
              <div class="input-box">
                <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/form_colleage_icon.png" alt="" />
                <div class="line"></div>
                <input type="text" placeholder="请输入报考院校" v-model="formData.college" maxlength="100" />
              </div>
              <div class="input-box">
                <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/form_user_icon.png" alt="" />
                <div class="line"></div>
                <input type="text" placeholder="请输入姓名" v-model="formData.name" maxlength="50" />
              </div>
              <div class="input-box">
                <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/form_phone_icon.png" alt="" />
                <div class="line"></div>
                <input type="text" placeholder="请输入手机号" v-model="formData.mobile" maxlength="11" />
              </div>
            </div>
            <div class="submit" @click="onSubmit">
              立即定制备考规划
              <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/form_free_icon.png" alt="" />
            </div>
            <div class="agree">
              <el-checkbox v-model="isAgree"
                >已经阅读并同意<a href="https://www.zhongke3.com/p/login/protocol?type=1" target="_blank">《服务协议》</a></el-checkbox
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="kxfd">
      <div class="w1200" style="margin-top: 280px">
        <div class="title-box">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/title_label_icon08.png" class="title-label" alt="" />
        </div>
        <div class="ensure">
          <ul>
            <li>
              <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/ensure_li_01.png" alt="" />
              <p>院校初定</p>
              <div>
                <span>初定2-3所目标院校</span>
                <span>匹配1对1辅导老师</span>
              </div>
            </li>
            <li>
              <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/ensure_li_02.png" alt="" />
              <p>基础规划</p>
              <div>
                <span>个人简历梳理</span>
                <span>综合能力评估</span>
                <span>塑造申请形象</span>
                <span>锁定目标院校</span>
              </div>
            </li>
            <li>
              <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/ensure_li_02.png" alt="" />
              <p>书面申请</p>
              <div>
                <span>梳理撰写思路</span>
                <span>自述文稿精修</span>
                <span>申请短文批改</span>
                <span>定稿申请素材</span>
              </div>
            </li>
            <li>
              <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/ensure_li_02.png" alt="" />
              <p>面试实战</p>
              <div>
                <span>面试模拟练习</span>
                <span>英语面试技巧</span>
                <span>面试拓展提升</span>
                <span>面试在线点评</span>
              </div>
            </li>
            <li>
              <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/ensure_li_02.png" alt="" />
              <p>提面结果</p>
              <div>
                <span>提面结果跟踪</span>
                <span>复试网课指导</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div id="sztd">
      <div class="title-box">
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/title_label_icon09.png" class="title-label" alt="" />
      </div>
      <div class="w1200">
        <el-carousel height="433px" :autoplay="false" arrow="never" ref="carousel">
          <el-carousel-item v-for="(item, index) in teachers" :key="index">
            <div class="teacher-box">
              <img :src="item.imgSrc" alt="" class="cover" />
              <div class="r-box">
                <h3>
                  {{ item.name }}<span>{{ item.education }}</span>
                </h3>
                <div class="btn">讲师介绍</div>
                <p v-html="item.intro"></p>
                <div class="btn">授课特点</div>
                <p>{{ item.feature }}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>

        <div class="photos">
          <ul>
            <li v-for="(item, index) in teachers" :key="index" @click="setActiveItem(index)">
              <img :src="item.photoSrc" alt="" :class="teacherIndex == index ? 'current' : ''" />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="w1200">
      <div class="title-box">
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/title_label_icon10.png" class="title-label" alt="" />
      </div>
      <div class="online">
        <ul>
          <li>
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/online_li_01.png" alt="" />
            <h3>课上特邀讲师讲核心</h3>
            <p>课程匠心打磨<br />考点精炼轻松学习</p>
          </li>
          <li>
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/online_li_02.png" alt="" />
            <h3>课下班主任全程督学</h3>
            <p>课前制定计划<br />课后督促指导复习</p>
          </li>
          <li>
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/online_li_03.png" alt="" />
            <h3>全天24小时答疑解惑</h3>
            <p>专业老师在线 <br />及时处理学科问题</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="dream">
      <div class="title-box">
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/title_label_icon11.png" class="title-label" alt="" />
      </div>
      <div class="w1200">
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/dream_word.png" alt="" />
      </div>
    </div>

    <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/bottom_bg.png" class="bottom-bg" alt="" />
    <myFooter theme="dark"></myFooter>

    <Dialog class="submit-dialog" title="定制成功！" :visible.sync="dialogVisible" center :show-close="false" width="460px">
      <div class="submitMian">
        中课网校指导老师会在24小时内致电您
        <br />
        请注意接听电话
      </div>
      <span slot="footer" class="dialog-footer">
        <button @click="dialogVisible = false">确定</button>
      </span>
    </Dialog>
  </div>
</template>
<script>
import { Dialog } from 'element-ui'
import { Message } from 'element-ui'
import md5 from 'js-md5'
import myFooter from '@/components/footer.vue'
import { graduatePromot } from '@/api/index'
import { phoneValidator } from '@/utils'

export default {
  metaInfo() {
    return {
      title: `考研提前面试-研究生备考辅导培训-中课网校`,
      meta: [
        {
          name: 'keywords',
          content: '考研面试,研究生面试,提前面试'
        },
        {
          name: 'description',
          content:
            '中课网校是专注学历提升，职业资格证书等在线报考，培训的学习平台，为广大学子提供考研公共课，专业课等全科辅导，有畅学班，全程班等授课，专注考研辅导，考研培训等多样课程满足各位学生的个性化需求。'
        }
      ]
    }
  },
  data() {
    return {
      currentNav: '',
      navigation: [
        { name: '报考条件', key: 'bktj' },
        { name: '报考流程', key: 'bklc' },
        { name: '提面优势', key: 'tmys' },
        { name: '师资团队', key: 'sztd' },
        { name: '科学教辅', key: 'kxfd' }
      ],
      teachers: [
        {
          imgSrc: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/lhy.png',
          photoSrc: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/lhy_profile.png',
          name: '刘海洋老师',
          education: '北京大学研究生，工程管理硕士',
          intro:
            '曾就职于国内某知名地产上市公司，拥有丰富的企业管理及创新创业经验，现担任某食品公司联合创始人、副总裁，负责战略制定、企业规范化、投融资等事务；担任多家培训机构的MBA、MEM项目主面试官，具有出色的面试培训能力及丰富的经验',
          feature:
            '擅长帮助考生系统梳理职业发展情况、全面认知自我，充分挖掘考生的职业亮点；帮助考生全面理解提前面试、笔试，依据考生个人背景情况，提出有针对性的面试建议和策略；擅长鼓舞和激发考生斗志，帮助考生树立信心，并为考生提供系统性的职业发展规划建议，助力考生全方位加速职业发展。'
        },
        {
          imgSrc: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/as.png',
          photoSrc: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/as_profile.png',
          name: '安爽老师',
          education: '韩国全南大学，MBA工商管理硕士',
          intro:
            '在韩国从事中韩教育研究工作，回国后，专注于中国MBA提前面试领域相关研究，目前主要负责中业MBA提前面试学员的材料审核与辅导。<br/>•在MBA/MPA申请材料的修改和面试相关理论知识方面有深入的研究，擅长针对考生的职业背景、所处的行业趋势挖掘考生材料背景亮点。',
          feature:
            '•对于销售领域从业以及自主创业的考生具备丰富的培训经验，擅长帮助考生梳理个人价值、行业发展价值、创业企业价值，让考生能在面试考场中从容应对考官的压力问题。'
        },
        {
          imgSrc: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/wyz.png',
          photoSrc: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/wyz_profile.png',
          name: '王英子老师',
          education: '北京理工大学 工商管理硕士 校级优秀研究生标兵',
          intro:
            '多年通信行业电商运营经历，在中国联通作为电商运营负责人，运作京东、绿森、普天太力等KA级大客户的电商合作项目，拥有处理多个客户整合项目的合作经验。借助MBA的深造，进入在线教育行业，拥有移动互联网教育中重要的用户增长及跨端项目协作经验。',
          feature:
            '通过自身经历成长，结合多年电商、移动互联网的项目运营经验，以及专业硕士的提前面试辅导经验，已成功帮助众多学生通过提前面试。在教学辅导过程中，会依据学生的发展方向以及思维模式，采取系统化、体系化的教学方式，协助学生挖掘自身特点准备材料，改善自身的思维理解模式，进而提高提面通过率，达成心仪学校的面试申请。'
        }
      ],
      teacherIndex: 0,
      isAgree: false,
      formData: {
        name: '',
        mobile: '',
        college: ''
      },
      dialogVisible: false
    }
  },
  components: {
    myFooter,
    Dialog
  },
  methods: {
    setScrollEvent(id) {
      this.currentNav = id
      $('html,body').animate({ scrollTop: $(`#${id}`).offset().top }, 0)
    },
    setActiveItem(index) {
      this.teacherIndex = index
      this.$refs.carousel.setActiveItem(index)
    },
    onSubmit() {
      if (!this.formData.college.length) {
        return Message.warning('请输入报考院校')
      }
      if (!this.formData.name.length) {
        return Message.warning('请输入姓名')
      }
      if (!this.formData.mobile.length) {
        return Message.warning('请输入手机号')
      }
      if (!phoneValidator(this.formData.mobile)) {
        return Message.warning('手机号格式错误')
      }
      if (!this.isAgree) {
        return Message.warning('请勾选服务协议')
      }

      const gt = new Date().getTime().toString()
      graduatePromot({
        time: gt,
        encryPwd: md5(gt + 'verify'),
        name: this.formData.name,
        mobile: this.formData.mobile,
        collegeName: '提前面试',
        orign: '自主注册',
        promotedAccount: 'SEO-考研提前面试页面',
        remark: `报考院校:${this.formData.college}`
      }).then(res => {
        this.dialogVisible = true
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  background: #edf5ff;
  .header {
    width: 100%;
    height: 744px;
    background: url(https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/header_bg.png) no-repeat center;
    .header-content {
      display: flex;
      align-items: center;
      height: 88px;
      background: rgba(255, 255, 255, 0.2);
      box-shadow: 0px 4px 32px 1px rgba(11, 42, 113, 0.05);
      .w1200 {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .logo {
          img {
            width: 170px;
            height: 50px;
          }
        }

        .nav-box {
          display: flex;

          .li {
            font-size: 16px;
            color: #fff;
            margin-left: 60px;
            cursor: pointer;
            position: relative;

            &.on {
              color: #fff;
              opacity: 1;
              font-weight: bold;
              &::after {
                position: absolute;
                bottom: -14px;
                left: 0;
                content: '';
                width: 100%;
                height: 4px;
                background: #fff;
                border-radius: 2px;
              }
            }
          }
        }
        .login {
          color: #fff;
        }
      }
    }
  }
  .title-box {
    display: flex;
    justify-content: center;
    width: 100%;
    .title-label {
      margin: 80px 0px 50px;
    }
  }

  #bktj {
    .advance {
      ul {
        display: flex;
        align-items: center;
        li {
          width: 585px;
          height: 375px;
          background: #ffffff;
          border-radius: 8px 8px 8px 8px;
          transition: all 0.2s;
          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 18px 10px rgb(11 42 113 / 5%);
          }
          &:not(:last-child) {
            margin-right: 30px;
          }
          h3 {
            margin-top: 20px;
            color: #333333;
            font-size: 30px;
            text-align: center;
          }
          p {
            color: #333333;
            font-size: 15px;
            line-height: 150%;
          }
          img {
            width: 585px;
            height: 210px;
          }
        }
      }
    }

    .compare {
      .compare-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 90px;
        padding-right: 132px;
        height: 91px;
        background: #538bf7;
        span {
          color: #ffffff;
          font-weight: 600;
        }
      }
      ul {
        li {
          display: flex;
          align-items: center;
          height: 57px;
          &:nth-child(odd) {
            background: #fff;
          }
          &:nth-child(even) {
            background: #fff9ea;
          }
          span {
            display: inline-block;
            color: #333333;
            font-size: 16px;
            text-align: center;
            &:nth-child(1) {
              width: 234px;
            }
            &:nth-child(2) {
              width: 581px;
            }
            &:nth-child(3) {
              width: 358px;
            }
          }
        }
      }
    }
  }
  #tmys {
    .advantage {
      ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        li {
          margin-right: 12px;
          margin-bottom: 12px;
          &:nth-child(3) {
            margin-right: 0;
          }
          img {
            width: 392px;
            height: 236px;
          }
        }
      }
    }
  }
  .analysis {
    background: url(https://zk-web-source.oss-cn-beijing.aliyuncs.com/interview/analysis_bg.png) no-repeat center;
    width: 100%;
    height: 1299px;
    margin-top: 48px;
    .title-label {
      margin: 258px 0px 75px;
    }
    .label {
      color: #fff;
      font-size: 22px;
      font-weight: bold;
      span {
        font-size: 16px;
        font-weight: normal;
      }
    }
    .content {
      margin-top: 28px;
      ul {
        display: flex;
        flex-wrap: wrap;
        li {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 380px;
          height: 209px;
          background: #ffffff;
          border-radius: 20px;
          margin-right: 30px;
          margin-bottom: 20px;
          transition: all 0.2s;
          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 18px 10px rgb(11 42 113 / 5%);
          }

          &:nth-child(3n) {
            margin-right: 0;
          }
          .l-box {
            flex-shrink: 0;
            width: 157px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .percent {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 71px;
              height: 71px;
              margin-bottom: 18px;
              border-radius: 50%;
              border: 2px solid #4582fb;
              color: #4582fb;
              font-size: 20px;
            }
            strong {
              display: block;
              text-align: center;
              color: #333333;
              font-size: 22px;
            }
          }
          .line {
            width: 0px;
            height: 141px;
            border: 1px dashed #c6c6c6;
          }
          .r-box {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            color: #333333;
            padding-left: 20px;
            padding-right: 20px;
          }
        }
      }
    }

    .table {
      margin-top: 42px;
      .table-title {
        display: flex;
        align-items: center;
        span {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 91px;
          color: #ffffff;
          font-size: 26px;
          font-weight: bold;
          &:nth-child(odd) {
            background: linear-gradient(180deg, #ff883c 0%, #f0383c 100%);
          }
          &:nth-child(even) {
            background: linear-gradient(180deg, #fb392a 0%, #fd6f50 100%);
          }
        }
      }
      ul {
        li {
          display: flex;
          align-items: center;
          &:nth-child(odd) {
            background: #fff;
          }
          &:nth-child(even) {
            background: #fff9ea;
          }
          span {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 57px;
            color: #333333;
            font-size: 16px;
          }
        }
      }
    }
  }
  #bklc {
    margin-top: 160px;
    .rule {
      ul {
        display: flex;
        li {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 380px;
          height: 481px;
          background: #ffffff;
          border-radius: 20px;
          margin-right: 30px;
          padding-top: 66px;
          transition: all 0.2s;
          box-sizing: border-box;

          &:nth-child(3n) {
            margin-right: 0;
          }
          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 18px 10px rgb(11 42 113 / 5%);
          }
          .top {
            p {
              font-size: 22px;
              color: #034de8;
              font-weight: bold;
              margin-bottom: 12px;
              text-align: center;
            }
            span {
              color: #999999;
              font-size: 16px;
            }
          }
          .des {
            margin-top: 59px;
            margin-bottom: 54px;
            p {
              color: #333333;
              font-size: 18px;
              text-align: center;
            }
          }
          .bottom {
            .button {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 248px;
              height: 57px;
              background: #5791ff;
              border-radius: 29px;
              color: #ffffff;
              font-size: 18px;
              &:nth-child(1) {
                background: #5791ff;
                margin-bottom: 15px;
              }
              &:nth-child(2) {
                background: #fbb718;
              }
            }
          }
        }
      }
    }

    .precept {
      position: relative;
      height: 782px;
      margin-top: 80px;

      .precept-bg {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 0;
      }
      .w1200 {
        position: relative;
        z-index: 1;
        .title-label {
          margin-top: 123px;
          margin-bottom: 95px;
        }
        .form {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          height: 405px;
          margin-top: 47px;
          background: #ffffff;
          border-radius: 20px;
          h3 {
            padding-top: 48px;
            color: #333333;
            font-size: 24px;
            text-align: center;
          }
          p {
            text-align: center;
            color: #999999;
            font-size: 18px;
          }
          .form-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 43px 85px 58px;
            .input-box {
              display: flex;
              align-items: center;
              width: 300px;
              height: 62px;
              &:not(:last-child) {
                margin-right: 65px;
              }
              border-radius: 5px;
              border: 1px solid #d8d8d8;
              padding: 0 20px;
              box-sizing: border-box;
              img {
                width: 29px;
                height: 29px;
              }
              .line {
                width: 0px;
                height: 28px;
                margin-left: 20px;
                margin-right: 16px;
                border: 1px solid #cccccc;
              }
              input {
                border: none;
                outline: none;
              }
            }
          }
          .submit {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 300px;
            height: 62px;
            background: linear-gradient(230deg, #ff883c 0%, #f0383c 100%);
            border-radius: 31px;
            font-size: 20px;
            color: #fff;
            cursor: pointer;
            img {
              position: absolute;
              right: 0;
              top: 0;
              margin-top: -10px;
              width: 69px;
              height: 29px;
            }
          }
          .agree {
            margin-top: 12px;
            font-size: 14px;
            ::v-deep .el-checkbox {
              .el-checkbox__label {
                color: #666 !important;
              }
            }

            a {
              color: #034de8;
            }
          }
        }
      }
    }
  }

  #kxfd {
    .ensure {
      ul {
        display: flex;
        li {
          position: relative;
          width: 235px;
          height: 297px;
          &:not(:last-child) {
            margin-right: 6px;
          }
          & > img {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 0;
          }
          p {
            position: relative;
            z-index: 1;
            font-size: 20px;
            font-weight: bold;
            color: #fff;
            margin-top: 64px;
            margin-left: 20px;
          }
          & > div {
            position: relative;
            display: flex;
            flex-direction: column;
            margin-top: 30px;
            span {
              display: flex;
              align-items: center;
              height: 37px;
              margin-left: 32px;
              margin-right: 20px;
              padding-left: 7px;
              &:nth-child(odd) {
                background: #fff;
              }
              &:nth-child(even) {
                background: #e4edfe;
              }
            }
          }
        }
      }
    }
  }

  #sztd {
    margin-top: 80px;
    height: 829px;
    background: linear-gradient(90deg, #3cb4ff 0%, #3867f1 100%);
    .teacher-box {
      display: flex;
      align-items: center;
      height: 433px;
      padding: 32px 20px 37px 37px;
      box-sizing: border-box;
      background: #ffffff;
      .cover {
        width: 276px;
        height: 364px;
        flex-shrink: 0;
        margin-right: 15px;
      }
      .r-box {
        h3 {
          display: flex;
          color: #333333;
          font-size: 24px;
          span {
            display: inline-block;
            padding-left: 17px;
            font-size: 18px;
            align-self: flex-end;
          }
        }
        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 103px;
          height: 38px;
          margin-top: 18px;
          margin-bottom: 12px;

          background: #fbb718;
          border-radius: 19px 19px 19px 19px;
          color: #fff;
          font-size: 18px;
        }
        p {
          color: #333333;
          font-size: 16px;
          line-height: 150%;
        }
      }
    }
    .photos {
      margin-top: 26px;
      ul {
        display: flex;
        align-items: center;
        li {
          &:not(:last-child) {
            margin-right: 100px;
          }
          img {
            width: 94px;
            height: 94px;
            box-sizing: border-box;
            border-radius: 50%;
            transition: all 0.2s;
            cursor: pointer;
            &.current {
              transform: scale(1.02);
              border: 1px solid #fbb718;
            }
          }
        }
      }
    }
  }
  .online {
    ul {
      display: flex;
      align-items: center;
      li {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 380px;
        height: 460px;
        padding-top: 36px;
        background: #ffffff;
        border-radius: 20px 20px 20px 20px;
        box-sizing: border-box;
        transition: all 0.2s;
        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 18px 10px rgb(11 42 113 / 5%);
        }
        &:not(:last-child) {
          margin-right: 30px;
        }
        img {
          width: 346px;
          height: 242px;
        }
        h3 {
          margin-top: 36px;
          font-size: 22px;
          color: #034de8;
        }
        p {
          margin-top: 18px;
          color: #333333;
          font-size: 18px;
          text-align: center;
        }
      }
    }
  }

  .dream {
    margin-top: 80px;
    height: 588px;
    background: #ffffff;
  }

  .bottom-bg {
    width: 100%;
    vertical-align: bottom;
  }

  .submit-dialog {
    .submitMian {
      font-size: 18px;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
      text-align: center;
    }

    .dialog-footer {
      button {
        width: 150px;
        height: 44px;
        background: linear-gradient(270deg, #3cb4ff 0%, #3867f1 100%);
        border-radius: 22px;
        border: none;
        font-size: 20px;
        color: #ffffff;
        cursor: pointer;
      }
    }

    ::v-deep .el-dialog {
      border-radius: 22px;
    }
  }
}
</style>
